import GameSprite from "./GameSprite";
import C_PointerEvt from "../const/C_PointerEvt";
import Physics from "./Physics";
import BaseComponent from "./BaseComponent";
import C_GameEvent from "../const/C_GameEvent";
import MotherOfTheMoonLogic from "./MotherOfTheMoonLogic";

class MotherOfTheMoon extends BaseComponent
{
    constructor()
    {
        super();

        // Scale 1 height = 220px (with stage scaleFactor ~0.5)
        this.baseHeight = 450;
        this.mc = this.entitySystem.mainView.mainContainer;
        this.assets = this.app.assets;
        this.layout = this.app.layout;

        this.waitingToShoot = false;
        this.isShooting = false;
        // ingame times:
        this.shootAnimTimes = [8, 8, 8, 8, 8, 8];
        this.projDelaySpawn = [3, 3, 3, 3, 3, 3];

        this.moonTextures = [
            "moon_white",
            "moon_red",
            "moon_blue",
            "moon_green",
            "moon_yellow",
            "moon_purple",
        ]

        this.create();
    }


    create()
    {
        // TODO - clean the factory on destroy?
        this.dgbFactory = dragonBones.PixiFactory.factory;

        this.dgbFactory.parseDragonBonesData(this.assets.getLoadedJSONData("motmSke"));
        this.dgbFactory.parseTextureAtlasData(this.assets.getLoadedJSONData("motmTex"),
            this.assets.getDragonBoneAtlasTexture("motmAtlas")
        );

        this.armatureName = "Armature";
        this.dgbName = "mothermoon_animation_all_state_final";

        this.motmIdleAnim = "mothermoon_idle";
        this.motmHurtAnim = "mothermoon_hurt";
        this.motmHandsAnim = [
            "mothermoon_idle_shoot_1",
            "mothermoon_idle_shoot_2",
            "mothermoon_idle_shoot_3",
            "mothermoon_idle_shoot_4",
            "mothermoon_idle_shoot_5",
            "mothermoon_idle_shoot_6"
        ]


        this.armatureDisplay = this.dgbFactory.buildArmatureDisplay(this.armatureName, this.dgbName);
        this.armatureDisplay.animation.play("mothermoon_idle");
        this.armatureDisplay.isDgbAnim = true;

        this.layout.horizontalAlignCenter(this.armatureDisplay);
        this.layout.verticalAlignMiddle(this.armatureDisplay);
        this.mc.addChild(this.armatureDisplay);
    }

    /**
     * Generates an array of textures.
     * @public
     * @param animation {Number} shows which hand animation should be played
     */
    playShootAnim(animation)
    {
        this.playingAnimation = animation;
        this.isShooting = true;

        let l = this.getEntity().getComponent(MotherOfTheMoonLogic);

        this.armatureDisplay.animation.play(this.motmHandsAnim[animation], 1);
        this.armatureDisplay.on(dragonBones.EventObject.COMPLETE, this.shootAnimationOver, this);


        return this.shootAnimTimes[animation];
    }


    playDamageAnim()
    {
        if (!this.isAnimPlaying() && !this.waitingToShoot)
        {
            // this.armatureDisplay.tint = 0xff0000;
            // // TweenMax.killTweensOf(sprite);
            // TweenMax.to(this.armatureDisplay, 0, {delay:.15, tint:0xffffff});
            this.armatureDisplay.animation.play(this.motmHurtAnim, 1);
            this.armatureDisplay.on(dragonBones.EventObject.COMPLETE, this.setIdleStateAnim, this);
        }
    }


    playDeathAnim()
    {
        TweenMax.to(this.armatureDisplay, .2, {alpha:0});
    }


    isAnimPlaying()
    {
        let isPlaying = false;
        if (this.armatureDisplay.animation.getState(this.motmHurtAnim))
        {
            isPlaying = true;
        }
        else
        {
            for (let i = 0; i < this.motmHandsAnim.length; i++)
            {
                if (this.armatureDisplay.animation.getState(this.motmHandsAnim[i]))
                {
                    isPlaying = true;
                    break;
                }
            }
        }

        return isPlaying;
    }


    // If the Mother is playing shoot animation
    getIsShooting()
    {
        return this.isShooting;
    }


    shootAnimationOver(e)
    {
        this.isShooting = false;
        this.playingAnimation = null;
        this.setIdleStateAnim();
    }


    setIdleStateAnim(e)
    {
        this.armatureDisplay.removeListener(dragonBones.EventObject.COMPLETE, this.onHitAnimationComplete, this);
        this.armatureDisplay.animation.play(this.motmIdleAnim);
    }


    getIdleState()
    {
        return this.armatureDisplay.animation.getState(this.motmIdleAnim);
    }


    setTarget()
    {
        this.target = this.app.assets.getSprite("target_red");
        this.target.anchor.set(.5,.5);
        // this.app.layout.propHeightScale(this.target, 80, this.sprite);
        let aspect = this.target.width / this.target.height;

        this.target.height = this.baseHeight * this.armatureDisplay.scale.y * .4;
        this.target.width = this.target.height * aspect;

        this.armatureDisplay.addChild(this.target);
        this.target.alpha = 0;
    }


    showTarget()
    {
        this.target.alpha = 1;
    }


    setReticle(reticle)
    {
        this.reticle = reticle;
    }


    hideTarget()
    {
        this.target.alpha = 0;
    }


    init()
    {
        super.init();
        TweenMax.from(this.armatureDisplay, this.fadeInTime, {alpha:0});
    }


    postPhysicsUpdate(delta)
    {
        // return;
        if (this.stopUpdate)
        {
            return;
        }

        let p = this.entity.getComponent(Physics);

        p.setSpriteRendered(true);
        let projected = this.app.layout.projectGameToScreen(p.position, p.getSize());


        this.armatureDisplay.x = projected.x;
        this.armatureDisplay.y = projected.y;
        this.armatureDisplay.sortZ = (p.position.z * 1000);

        let scaleRatio = projected.z / this.baseHeight;
        this.armatureDisplay.scale.x = this.armatureDisplay.scale.y = scaleRatio;

        this.updateReticlePosition();
    }


    updateReticlePosition()
    {
        if (this.reticle)
        {
            let mv = this.entitySystem.mainView;
            let mc = mv.mainContainer;

            let pos = mv.toLocal(mc.toGlobal(new PIXI.Point(this.armatureDisplay.x, this.armatureDisplay.y)));
            this.reticle.x = pos.x;
            this.reticle.y = pos.y;
        }
    }


    getSprite()
    {
        return this.armatureDisplay;
    }


    destroy()
    {
        super.destroy();
        if (this.armatureDisplay.parent)
        {
            this.armatureDisplay.parent.removeChild(this.armatureDisplay);
        }
    }

    // create()
    // {
    //     super.create();
    //     this.isVanishing = false;
    //
    //     this.sprite.anchor.set(.5,.5);
    //
    //     let leftHandTextures = this.app.assets.generateFrames("motm_leftHand_", 0, 0, 2);
    //     this.leftHand = new PIXI.Sprite(leftHandTextures[0]);
    //     this.leftHand.anchor.set(0.5, 0.5);
    //     this.sprite.addChild(this.leftHand);
    //     this.leftHandAnimation = new PIXI.extras.AnimatedSprite(leftHandTextures);
    //     this.leftHandAnimation.anchor.set(0.5, 0.5);
    //     this.leftHandAnimation.loop = false;
    //     this.leftHandAnimation.animationSpeed = 0.1;
    //     this.leftHandAnimation.onComplete = this.onLeftAnimComplete.bind(this);
    //     this.sprite.addChild(this.leftHandAnimation);
    //
    //
    //     let rightHandTextures = this.app.assets.generateFrames("motm_rightHand_", 0, 0, 2);
    //     this.rightHand = new PIXI.Sprite(rightHandTextures[0]);
    //     this.rightHand.anchor.set(0.5, 0.5);
    //     this.sprite.addChild(this.rightHand);
    //     this.rightHandAnimation = new PIXI.extras.AnimatedSprite(rightHandTextures);
    //     this.rightHandAnimation.anchor.set(0.5, 0.5);
    //     this.rightHandAnimation.loop = false;
    //     this.rightHandAnimation.animationSpeed = 0.1;
    //     this.rightHandAnimation.onComplete = this.onRightAnimComplete.bind(this);
    //     this.sprite.addChild(this.rightHandAnimation);
    //
    //
    //     let midHandTextures = this.app.assets.generateFrames("motm_midHand_", 0, 0, 2);
    //     this.midHand = new PIXI.Sprite(midHandTextures[0]);
    //     this.midHand.anchor.set(0.5, 0.5);
    //     this.sprite.addChild(this.midHand);
    //     this.midHandAnimation = new PIXI.extras.AnimatedSprite(midHandTextures);
    //     this.midHandAnimation.anchor.set(0.5, 0.5);
    //     this.midHandAnimation.loop = false;
    //     this.midHandAnimation.animationSpeed = 0.1;
    //     this.midHandAnimation.onComplete = this.onMidAnimComplete.bind(this);
    //     this.sprite.addChild(this.midHandAnimation);
    //
    //     this.animationDuration = 0;
    //     this.handsIds = {
    //         0: this.midHand,
    //         1: this.leftHand,
    //         2: this.rightHand
    //     }
    //     this.animationsIds = {
    //         0: this.midHandAnimation,
    //         1: this.leftHandAnimation,
    //         2: this.rightHandAnimation
    //     }
    //
    //
    //     this.sprite.alpha = 0;
    //
    //     this.playSlowSpawnAnim(2);
    // }
    //
    //
    // init()
    // {
    //
    // }
    //
    //
    // playShootAnimation(handId, delay)
    // {
    //     TweenMax.delayedCall(delay/4 - this.animationDuration, this.playAnim.bind(this), [handId]);
    // }
    //
    //
    // playAnim(handId)
    // {
    //     this.handsIds[handId].alpha = 0;
    //
    //     this.animationsIds[handId].alpha = 1;
    //     this.animationsIds[handId].gotoAndPlay(0);
    // }
    //
    //
    // onLeftAnimComplete()
    // {
    //     let id = 1;
    //
    //     this.handsIds[id].alpha = 1;
    //
    //     this.animationsIds[id].alpha = 0;
    // }
    //
    //
    // onRightAnimComplete()
    // {
    //     let id = 2;
    //     this.handsIds[id].alpha = 1;
    //
    //     this.animationsIds[id].alpha = 0;
    // }
    //
    //
    // onMidAnimComplete()
    // {
    //     let id = 0;
    //     this.handsIds[id].alpha = 1;
    //
    //     this.animationsIds[id].alpha = 0;
    //
    //
    // }
    //
    //
    // playSlowSpawnAnim(dur)
    // {
    //     // let tintOverlay = this.app.assets.getSprite(this.textureId);
    //     // tintOverlay.alpha = 0.5;
    //     // tintOverlay.anchor.set(.5,.5);
    //     // tintOverlay.tint = 0x000000;
    //     // this.sprite.addChild(tintOverlay);
    //     // TweenMax.to(tintOverlay, dur, {alpha:0, onComplete:this.removeOverlay.bind(this), onCompleteParams:tintOverlay});
    //
    //     this.setCanShoot(false);
    //     TweenMax.to(this.sprite, dur, {alpha:0.71});
    //     TweenMax.delayedCall(dur, this.setCanShoot, [true], this);
    // }
    //
    //
    // playVanishAnimation(dur = 4)
    // {
    //     if (!this.isVanishing)
    //     {
    //         this.isVanishing = true;
    //         this.setCanShoot(false);
    //         TweenMax.to(this.sprite, dur, {alpha:0});
    //         this.delayedQueueForRemoval(dur);
    //     }
    // }
    //
    //
    // addBlinkOverlay(tweenTime, delay = 2)
    // {
    //     let overlay = this.app.assets.getSprite(this.textureId + "_over");
    //     overlay.anchor.set(.5,.5);
    //     this.sprite.addChild(overlay);
    //     TweenMax.from(overlay, tweenTime, {alpha:0, yoyo:true, repeat:-1, delay: delay});
    // }
    //
    //
    // playDeathAnim()
    // {
    //     this.isVanishing = true;
    //     this.setCanShoot(false);
    //     TweenMax.to(this.sprite, 1, {alpha:0});
    // }
    //
    //
    // playMuzzleFlash(xOffset, yOffset)
    // {
    //
    // }
    //
    //
    // setCanShoot(val)
    // {
    //     this.canShoot = val;
    // }
    //
    //
    // getCanShoot()
    // {
    //     return this.canShoot;
    // }
    //
    //
    // removeOverlay(overlay)
    // {
    //     this.sprite.removeChild(overlay);
    // }

}

export default MotherOfTheMoon;